import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { Overview } from './tabContent/Overview'
import { RegularContentTab } from './tabContent/RegularContentTab'
import { Thread } from '../../../../components/blocks/thread/Thread'
import { useParamState } from '@app/util/hooks/useParamState'
import { ViewPlotModel } from 'functions/app/plot/view'
import { mapPageContentBlocksToSections } from '@app/components/blocks/contentSection/mapPageContentBlocksToSections'
import { plotTabs } from './plotTabs'

export const TabContent = ({ plot }: { plot: ViewPlotModel }) => {
  const translations = useTranslations().app.plotPage
  const [tab, setTab] = useParamState(plotTabs)
  const applicationTabSections = mapPageContentBlocksToSections(
    plot.contentBlocks?.filter((c) => c.$position === 'applicationTab') ?? [],
  )
  const documentsTabSections = mapPageContentBlocksToSections(
    plot.contentBlocks?.filter((c) => c.$position === 'documentsTab') ?? [],
  )
  return (
    <Column alignItems="stretch" gap="2rem">
      <TabsGroup
        selectedTab={tab}
        onSelectTab={setTab}
        tabs={[
          { label: translations.overview, value: plotTabs.overview },
          {
            label: translations.applicationProcedure,
            value: plotTabs.application,
            isVisible: plot.byCrowdbuilding,
          },
          {
            label: translations.documents,
            value: plotTabs.documents,
            isVisible: plot.byCrowdbuilding,
          },
          { label: translations.thread, value: plotTabs.thread },
        ]}
      />
      {match(tab)
        .with(plotTabs.overview, () => <Overview key="overview" plot={plot} />)
        .with(plotTabs.application, () => (
          <RegularContentTab
            key="application"
            sections={applicationTabSections}
          />
        ))
        .with(plotTabs.documents, () => (
          <RegularContentTab key="documents" sections={documentsTabSections} />
        ))
        .with(plotTabs.thread, () =>
          plot.thread?.id ? (
            <Thread key="thread" threadId={plot.thread.id} />
          ) : null,
        )
        .exhaustive()}
    </Column>
  )
}
